import sketch1 from '../assets/images/sketchbook-1.webp';
import sketch2 from '../assets/images/sketchbook-2.webp';
import sketch3 from '../assets/images/sketchbook-3.webp'
import sketch4 from '../assets/images/sketchbook-4.webp'
import sketch5 from '../assets/images/sketchbook-5.webp'
import sketch6 from '../assets/images/sketchbook-6.webp';
import sketch7 from '../assets/images/sketchbook-7.webp'
import sketch8 from '../assets/images/sketchbook-8.webp'
import sketch9 from '../assets/images/sketchbook-9.webp'
import sketch10 from '../assets/images/sketchbook-10.webp'
import sketch11 from '../assets/images/sketchbook-11.webp'
import sketch12 from '../assets/images/sketchbook-12.webp'
import sketch13 from '../assets/images/sketchbook-13.webp'
import sketch14 from '../assets/images/sketchbook-14.webp'
import sketch15 from '../assets/images/sketchbook-15.webp'
import sketch16 from '../assets/images/sketchbook-16.webp';
import sketch17 from '../assets/images/sketchbook-17.webp';
import sketch18 from '../assets/images/sketchbook-18.webp';
import sketch19 from '../assets/images/sketchbook-19.webp';
import sketch20 from '../assets/images/sketchbook-20.webp';
import sketch21 from '../assets/images/sketchbook-21.webp'
import sketch22 from '../assets/images/sketchbook-22.webp'
import sketch23 from '../assets/images/sketchbook-23.webp';
import sketch24 from '../assets/images/sketchbook-24.webp';


export const sketchbookImages = [
    {
        src: sketch24,
        alt: 'sketch 24'
    },
    {
        src: sketch23,
        alt: 'sketch 23'
    },
    {
        src: sketch22,
        alt: 'sketch 22'
    },
    {
        src: sketch21,
        alt: 'sketch 21'
    },
    {
        src: sketch20,
        alt: 'sketch 20'
    },
    {
        src: sketch19,
        alt: 'sketch 19'
    },
    {
        src: sketch18,
        alt: 'sketch 18'
    },
    {
        src: sketch17,
        alt: 'sketch 17'
    },
    {
        src: sketch16,
        alt: 'sketch 16'
    },
    {
        src: sketch15,
        alt: 'sketch 15'
    },
    {
        src: sketch14,
        alt: 'sketch 14'
    },
    {
        src: sketch13,
        alt: 'sketch 13'
    },
    {
        src: sketch12,
        alt: 'sketch 12'
    },
    {
        src: sketch11,
        alt: 'sketch 11'
    },
    {
        src: sketch10,
        alt: 'sketch 10'
    },
    {
        src: sketch9,
        alt: 'sketch 9'
    },
    {
        src: sketch8,
        alt: 'sketch 8'
    },
    {
        src: sketch7,
        alt: 'sketch 7'
    },
    {
        src: sketch6,
        alt: 'sketch 6'
    },
    {
        src: sketch5,
        alt: 'sketch 5'
    },
    {
        src: sketch4,
        alt: 'sketch 4'
    },
    {
        src: sketch3,
        alt: 'sketch 3'
    },
    {
        src: sketch2,
        alt: 'sketch 2'
    },
    {
        src: sketch1,
        alt: 'sketch 1'
    }
]
